import { useCallback, useRef } from "react"
type noop = (this: any, ...args: any[]) => any

export function useEvent<T extends noop>(handler: T) {
    const handlerRef = useRef<T>(handler)
    handlerRef.current = handler

    return useCallback<(...args: Parameters<T>) => ReturnType<T>>((...args) => {
        const fn = handlerRef.current
        return fn(...args)
    }, [])
}
